<script setup>
  import {computed} from "vue";

  import ComponentAiSummaryDialog from "@components/Dialogs/AiSummaryDialog.vue";
  import {usePage} from "@inertiajs/vue3";
  import {MedButton, MedTooltip} from "@pharma4u/medicheck-components";

  defineOptions({
    name: "ComponentAiSummaryButton",
  });

  const props = defineProps({
    target: {
      type: String,
      required: true,
    },
    checks: {
      type: Array,
      required: true,
    },
    patient: {
      type: Object,
      required: true,
    },
    record: {
      type: Object,
      required: true,
    },
  });

  const page = usePage();

  const selectedClaims = computed(() => {
    return props.checks.flatMap((check) =>
      check.claims.filter((claim) => {
        if (props.target === "doctor") {
          return claim.communicationdoc;
        }
        return claim.communicationpatient;
      }),
    );
  });

  const summaryDisabledReason = computed(() => {
    if (!page.props.can.allow_ai_summary) {
      return "Diese KI-Funktion steht Ihnen im MediCheck Pro zur Verfügung.";
    }

    if (!page.props.can.activate_ai_features) {
      return "Um die KI-Zusammenfassung zu nutzen, schalten Sie bitte die KI-Funktionen in Ihren Einstellungen frei.";
    }

    if (selectedClaims.value.length === 0) {
      return "Für die KI-Zusammenfassung wählen Sie bitte mindestens ein Checkergebnis aus.";
    }

    if (selectedClaims.value.length > 10) {
      return "Es können maximal 10 Check-Ergebnisse zusammengefasst werden. Bitte reduzieren Sie Ihre Auswahl.";
    }

    return null;
  });
</script>

<template>
  <MedTooltip :content="summaryDisabledReason" :disabled="summaryDisabledReason === null">
    <MedButton
      icon="auto_awesome"
      :disabled="summaryDisabledReason !== null"
      :data-test="getTestId('open-summarize-claims-dialog-button')"
      @click="$refs.aiSummaryDialog.open()"
    >
      Zusammenfassung erstellen
    </MedButton>
  </MedTooltip>

  <ComponentAiSummaryDialog ref="aiSummaryDialog" :record="record" :patient="patient" :target="target" />
</template>
